import React, { Component } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import _ from "lodash";

export default class UserCell extends Component {
  renderCheckoutValues = () => {
    let { user } = this.props;
    var responses = JSON.parse(user.responses);

    return _.map(responses, (obj) => {
      if (
        obj.name != "termsconditions" &&
        obj.name != "isnetworking" &&
        obj.key != "hyperlink" &&
        obj.key != "label" &&
        obj.key != "paragraph"
      ) {
        if (
          obj.key === "checkboxes" ||
          obj.key === "radiobuttons" ||
          obj.key === "dropdown"
        ) {
          let optionsdata = obj.options;
          let value = "";
          if (obj.key === "checkboxes" && Array.isArray(obj.value)) {
            let chekckBoxValue = [];
            obj.value.map((box) => {
              let match = _.filter(optionsdata, (o) => {
                return (
                  o.text.toLowerCase() == box.toLowerCase() ||
                  o.value.toLowerCase() == box.toLowerCase()
                );
              });

              if (match.length > 0) {
                chekckBoxValue.push(match[0].text);
              }

              value = chekckBoxValue.join(", ");
            });
          } else {
            let match = _.filter(optionsdata, (o) => {
              return (
                o.text.toLowerCase() == obj.value.toLowerCase() ||
                o.value.toLowerCase() == obj.value.toLowerCase()
              );
            });

            if (match.length > 0) {
              value = match[0].text;
            }
          }

          return (
            <td
              key={`key_td_${obj.name}`}
              style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
            >
              {value}
            </td>
          );
        } else {
          return (
            <td
              key={`key_td_${obj.name}`}
              style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
            >
              {obj.value}
            </td>
          );
        }
      }
    });
  };

  render() {
    var { user } = this.props;

    return (
      <tr
        style={
          user.hasErrors.length > 0
            ? { backgroundColor: "#ff000038", display: "flex" }
            : { display: "flex" }
        }
      >
        <td>
          <div className="vertical-align-center">
            {user.rowno}{" "}
            {user.hasErrors.length > 0 ? (
              <OverlayTrigger
                id="overlay-trigger"
                key="refresh"
                placement="top"
                overlay={
                  <Popover id="popover-basic">
                    {user.hasErrors.join(", ")}
                  </Popover>
                }
              >
                <i
                  className="fa fa-exclamation-circle"
                  aria-hidden="true"
                  style={{ float: "right", color: "red", margin: 7 }}
                ></i>
              </OverlayTrigger>
            ) : (
              ""
            )}
          </div>
        </td>
        <td>{user.firstname}</td>
        <td>{user.lastname}</td>
        <td style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
          {user.email}
        </td>
        <td>{user.userstatus}</td>
        <td>{user.category}</td>
        <td>
          {user.isnetworking === 1
            ? "yes"
            : user.isnetworking === 0
            ? "no"
            : ""}
        </td>
        {/* <td>{profileurl}<br/>{rest}</td> */}
        <td style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
          {user.profileurl}
        </td>
        {this.renderCheckoutValues()}
      </tr>
    );
  }
}
